import { render, staticRenderFns } from "./VoiceSelecter.vue?vue&type=template&id=65554bc8&"
import script from "./VoiceSelecter.vue?vue&type=script&lang=js&"
export * from "./VoiceSelecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports